// localStorage helpers for auth state only
// All business data (customers, jobs, etc.) lives in the backend database

export const saveToLocalStorage = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getFromLocalStorage = (key) => {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (e) {
    console.error(`localStorage parse error for key "${key}":`, e);
    return null;
  }
};

export const removeFromLocalStorage = (key) => {
  localStorage.removeItem(key);
};

// Service types reference (read-only, not stored)
export const serviceTypes = [
  { id: 1, name: 'Şeffaf Kaplama (PPF)', basePrice: 15000 },
  { id: 2, name: 'Renkli Araç Kaplama', basePrice: 12000 },
  { id: 3, name: 'Araç Cam Filmi', basePrice: 3500 },
  { id: 4, name: 'Bina Cam Filmi', basePrice: 2500 },
  { id: 5, name: 'Özel Tasarım Baskı', basePrice: 8000 },
  { id: 6, name: 'Detaylı Temizlik', basePrice: 1500 },
  { id: 7, name: 'Pasta Cila', basePrice: 2000 },
  { id: 8, name: 'Seramik Kaplama', basePrice: 5000 },
  { id: 9, name: 'Tekne Kaplama', basePrice: 20000 },
  { id: 10, name: 'Tekne Cam Filmi', basePrice: 5000 },
];

// No-op: mock data initialization removed. All data comes from backend.
export const initializeMockData = () => {};
